import React,{useState} from 'react';
import { Router, Location, Redirect } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
import PublicMenu from './menus/PublicMenu';
import HBG from './../assets/background/home.png';
import HBG2 from './../assets/background/home2.jpg';
import IPFSICON from './../assets/icons/ipfsIcon.svg';
const URLPREFIX=process.env.REACT_APP_URLPREFIX;
const URLHOST=process.env.REACT_APP_UI_SERVER;
const GlobalStyles = createGlobalStyle`
	#hbg-carousel {
		height:650px!important;
		overflow:hidden;
	}
	.z--1{ z-index:-1;}
	.z-1{ z-index:1;}
	
	.jbox-bg-primary{
		background-color:#fafafa;
	}
	.page-bk{
	background-image:url(${URLHOST+"/images/BGSUog.webp"});
	background-size:cover;
	background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center;
	background-repeat: no-repeat;
	}
	.hbanner-9090{
	background-image:url(${URLHOST+"/images/BGSUog.webp"});
	background-size:cover;
	background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center;
	background-repeat: no-repeat;
	/*-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	-webkit-animation: zoomin 10s ease-in infinite;
	animation: zoomin 10s ease-in infinite;
	transition: all .5s ease-in-out;*/
	overflow: hidden;
	}
	.hb-ititle-3{ font-size:3rem;}
	.hb-ititle-4{ font-size:4rem;}
	.hb-ititle-5{ font-size:5rem;}
	
	
	@-webkit-keyframes zoomin {
	  0% {transform: scale(1);}
	  50% {transform: scale(1.5);}
	  100% {transform: scale(1);}
	}
	
	.hbanner-9091{
	background-color:#000000;
	background-image:url(${URLHOST+"/images/T1002.jpg"});
	background-size:cover;
	background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: left bottom;
	background-repeat: no-repeat;
	
	
	}
	
	.hbanner-9092{
	background-image:url(${URLHOST+"/images/T1004.jpg"});
	background-size:cover;
	background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center;
	background-repeat: no-repeat;
	
	}
	.box-9090{ width:220px; height:220px;}
	.bg-9090{ background-image: linear-gradient(to right,#000000,#161819,#000000);
			overflow:hidden;
			}
	.fo a { text-decoration:none;font-size:0.85rem; }		
	.fo-hr{width: 60px; background-color: #fefefe; height: 1px}		
`;
const App= () =>{
  const [flag,setFlag]=useState(true);
  return(
  <div className="w-100 page-bk">
	<GlobalStyles/>
	<PublicMenu />
	{flag===true &&
	<>
	<div className='vh-100 hbanner-9090'>
		<div className='row g-0'>
			<div className='col-md-9'>
				<div className='px-4'>
						<div className='d-flex align-items-start flex-column vh-100' style={{paddingBottom:'8rem'}}>
						<div className="mb-auto p-2 bd-highlight"></div>
						<div className='w-75'>
						<p className='hb-ititle-3 text-white'>Blacknight Smart Contract</p>
						<p className='fs-3 text-white'>Records generated timestamp is machine generated on</p>
						</div>
					</div>
				</div>
			</div>
			<div className='position-relative col-md-3 vh-100 '>
				<div className="position-absolute d-flex w-100 vh-100 bg-dark opacity-75">
				</div>
				<div className="position-absolute d-flex w-100 vh-100 justify-content-center align-items-center">
					<div className='row g-0 flex-fill '>
						<div className="col-md-12 px-4 ">
							<div className="mb-3 mt-3">
							  <div className='fs-5 text-white'>Login</div>
							</div>
							<div className="form-floating mb-3 mt-3">
							  <input type="text" className="form-control" id="email" placeholder="Enter email" />
							  <label>Email</label>
							</div>

							<div className="form-floating mt-3 mb-3">
							  <input type="text" className="form-control" id="pwd" placeholder="Enter password" />
							  <label>Password</label>
							</div>
							<div className="mt-3 mb-3">
							  <input type="button" className="btn btn-primary w-100" id="submit" value="Login" />
							</div>
							<div className="mt-4 mb-4">
							  <p className='fs-7 text-white text-center'>
								If you have no account, please <a href="#" className='text-white'>register here</a>
							  </p>
							</div>
						</div>
					</div>	
				</div>
			</div>
		</div>	
	</div>
	
	<div className='hbanner-9091 p-4'>
		<div className='row g-0 '>
			<div className='col-md-7'>
				<div className='px-4'>
						<div className='d-flex align-items-start flex-column ' style={{paddingTop:'5rem'}}>
						<div className='w-100 bg-light rounded-4 p-4 opacity-75'>
							<p className='hb-ititle-3 text-dark'>Certificate Smart Contract</p>
							<div className='d-flex fs-3 text-dark mb-2'>
								<i className="bi bi-link-45deg"></i> 
								Upload your documents in blockhain file server and protect from hampering.
							</div>
							<div className='d-flex fs-3 text-dark mb-2'>
								<i className="bi bi-link-45deg"></i> 
								One one can issue backdate certificate.
							</div>
							<div className='d-flex fs-3 text-dark'>
								<i className="bi bi-link-45deg"></i>Verify the certificate.
							</div>
						</div>	
					</div>
				</div>
			</div>
		</div>	
		<div className="w-100 h-50 pt-4">
			<div className='d-flex justify-content-center'>
				<div className='box-9090 bg-9090 rounded-circle ms-4 d-flex align-items-center'>
					<div className='bg-primary w-100 bg-dark p-2'>
						<div className='text-center fs-1 text-white'><i className="bi bi-link-45deg"></i></div>
						<div className='text-center fs-4 text-white'>Smart Contract</div>
					</div>	
				</div>
				<div className='box-9090 bg-9090 rounded-circle ms-4 d-flex align-items-center'>
					<div className='bg-primary w-100 bg-dark p-2'>
						<div className='text-center fs-1 text-white'><img src={IPFSICON} /></div>
						<div className='text-center fs-4 text-white'>IPFS</div>
					</div>	
				</div>
				<div className='box-9090 bg-9090 rounded-circle ms-4 d-flex align-items-center'>
					<div className='bg-primary w-100 bg-dark p-2'>
						<div className='text-center fs-1 text-white'><i className="bi bi-circle"></i></div>
						<div className='text-center fs-4 text-white'>HCS</div>
					</div>	
				</div>
			</div>
		</div>
	</div>	
	</>
	}
	<div className='hbanner-9092 vh-100'>
		
		<div className='row g-0 '>
			<div className='col-md-7'>
				<div className='px-4'>
						<div className='d-flex align-items-start flex-column ' style={{paddingTop:'5rem'}}>
						<div className='w-100 bg-light rounded-4 p-4 opacity-75'>
						<p className='hb-ititle-3 text-dark'>Today's web can't preserve humanity's history</p>
						<p className='fs-3 text-dark'>Records generated timestamp is machine generated on blockchain,
													  that will not be modified by any one , that's causes your record is very easily validated by time</p>
						</div>
					</div>
				</div>
			</div>
			<div className='col-md-5'>
				<div className='px-4'>
						<div className='d-flex align-items-start flex-column ' style={{paddingTop:'5rem'}}>
						<div className='w-100 bg-light rounded-4 p-4 opacity-75'>
						<p className='hb-ititle-3 text-dark'>Immutable Records</p>
						<p className='fs-3 text-dark'>No one has power to modify the records</p>
													  
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	
	<div className="my-0 fo" style={{opacity:0.97}}>
	  <footer
			  className="text-center text-lg-start text-dark"
			  style={{backgroundColor: "#ffffff"}}
			  >
		<section
				 className="d-flex justify-content-between p-4 text-dark fs-6"
				 style={{backgroundColor: "#ffffff"}}
				 >
		  <div className="me-5">
			<span>Get connected with us on social networks</span>
		  </div>
		  <div>
			<a href="" className="text-white me-4">
			  <i className="fab fa-facebook-f"></i>
			</a>
			<a href="" className="text-white me-4">
			  <i className="fab fa-twitter"></i>
			</a>
			<a href="" className="text-white me-4">
			  <i className="fab fa-google"></i>
			</a>
			<a href="" className="text-white me-4">
			  <i className="fab fa-instagram"></i>
			</a>
			<a href="" className="text-white me-4">
			  <i className="fab fa-linkedin"></i>
			</a>
			<a href="" className="text-white me-4">
			  <i className="fab fa-github"></i>
			</a>
		  </div>
		</section>
		<section className="">
		  <div className="container text-center text-md-start mt-5">
			<div className="row mt-3">
			  <div className="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
				<h6 className="text-uppercase fw-bold">Company name</h6>
				<hr
					className="mb-4 mt-0 d-inline-block mx-auto fo-hr"
					/>
				<p>
				  Here you can use rows and columns to organize your footer
				  content. Lorem ipsum dolor sit amet, consectetur adipisicing
				  elit.
				</p>
			  </div>
			  <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
				<h6 className="text-uppercase fw-bold">Products</h6>
				<hr
					className="mb-4 mt-0 d-inline-block mx-auto fo-hr"
					/>
				<p>
				  <a href="#!" className="text-dark">MDBootstrap</a>
				</p>
				<p>
				  <a href="#!" className="text-dark">MDWordPress</a>
				</p>
				<p>
				  <a href="#!" className="text-dark">BrandFlow</a>
				</p>
				<p>
				  <a href="#!" className="text-dark">Bootstrap Angular</a>
				</p>
			  </div>
			  <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
				<h6 className="text-uppercase fw-bold">Useful links</h6>
				<hr
					className="mb-4 mt-0 d-inline-block mx-auto fo-hr"
					
					/>
				<p>
				  <a href="#!" className="text-dark">Your Account</a>
				</p>
				<p>
				  <a href="#!" className="text-dark">Become an Affiliate</a>
				</p>
				<p>
				  <a href="#!" className="text-dark">Shipping Rates</a>
				</p>
				<p>
				  <a href="#!" className="text-dark">Help</a>
				</p>
			  </div>
			  <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
				<h6 className="text-uppercase fw-bold">Contact</h6>
				<hr
					className="mb-4 mt-0 d-inline-block mx-auto fo-hr"
					
					/>
				<p><i className="fas fa-home mr-3"></i> New York, NY 10012, US</p>
				<p><i className="fas fa-envelope mr-3"></i> info@example.com</p>
				<p><i className="fas fa-phone mr-3"></i> + 01 234 567 88</p>
				<p><i className="fas fa-print mr-3"></i> + 01 234 567 89</p>
			  </div>
			</div>
		  </div>
		</section>
		<div
			 className="d-flex justify-content-between p-3 border-top"
			 style={{backgroundColor: '#fefefe'}}
			 >
		  <div>© 2020 Copyright:
		  <a className="text-dark" href="https://mdbootstrap.com/">MDBootstrap.com</a> </div>
		  <div>.</div>
		</div>
	  </footer>
	</div>
	
	
  </div>
  );
};
export default App;